import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { useNavigation } from "@react-navigation/native"
import { StatusBar } from "@common/systemBars/StatusBar"
import React, { useContext, useEffect } from "react"
import { View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import { connect } from "react-redux"
import TextM from "../../../common/components/text/TextM"
import TitleM from "../../../common/components/text/TitleM"
import { useCurrentActivity } from "../../../common/hooks/useCurrentActivity"
import { theme } from "../../../common/theme/theme"
import { DimensionsContext } from "../../../common/utils/mobileUtils"
import { ChampionImageM } from "../../champions/ChampionImageM"
import StaticOneStepActivityHeader from "../one-step/StaticOneStepActivityHeader"

const ActivityWaitingScreen = (props) => {
    const { loading, route } = props
    const dimensions = useContext(DimensionsContext)
    const navigation = useNavigation()
    const { setCurrentActivity } = useCurrentActivity()

    useEffect(() => {
        if (!props.isLive) {
            setCurrentActivity(null)
            navigation.goBack()
        }
    }, [props.isLive])

    if (!props.isLive) {
        return
    }

    return (
        <>
            <StaticOneStepActivityHeader
                onExit={() => navigation.goBack()}
                route={route}
            />
            {!loading ? (
                <View
                    style={{
                        flex: 1,
                        alignItems: "center",
                        alignContent: "center",
                        justifyContent: "center",
                        alignSelf: "center",
                        paddingHorizontal: 15,
                        width: dimensions?.width,
                    }}
                >
                    <ChampionImageM
                        name="zoe"
                        variant={"main"}
                        width={dimensions?.width >= 800 ? dimensions?.width / 6 : dimensions?.width / 4}
                        style={{
                            marginTop: -100
                        }}
                    />
                    <TitleM
                        fontWeight="ExtraBold"
                        style={{
                            textAlign: "center",
                            marginTop: 10,
                            color: theme.colors.grey,
                            fontSize: 24,
                        }}
                        wrap
                    >
                        Tu n'as plus d'activités
                    </TitleM>
                    <TextM
                        fontWeight="Medium"
                        style={{ textAlign: "center" }}
                        fontSize={20}
                        wrap
                    >
                        Ton masteur va t'en ajouter sous peu !{" "}
                    </TextM>
                    <StatusBar
                        style="dark"
                        backgroundColor={theme.colors.white}
                        translucent={false}
                    />
                </View>
            ) : (
                <View
                    style={{
                        flex: 1,
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <ActivityIndicator
                        animating={true}
                        style={{ marginTop: 10 }}
                        color={theme.colors.primary}
                        size={40}
                    />
                </View>
            )}
            <StatusBar
                style="dark"
                backgroundColor={theme.colors.white}
                translucent={false}
            />
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        getActivitiesRequest: state.api.getActivities?.request,
        getActivitiesSuccess: state.api.getActivities?.success,
        getActivitiesError: state.api.getActivities?.error,
        activityTemplates: state.data.staticData?.activity_templates,
        schoolSubjects: state.data.staticData?.school_subjects,
        user: state.data.currentUser?.object,
        liveSessions: state.data.currentUser?.object?.live_sessions,
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        ),
        liveSessionId: state.liveMode?.liveSessionId,
        isLive: state.liveMode?.isLiveModeEnabled,
        activityTodoAsStudentRequest: state.api.activityTodoAsStudent?.request,
        activityTodoAsTutorRequest: state.api.activityTodoAsTutor?.request,
        currentActivity: state.data?.currentActivity.activity,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ActivityWaitingScreen)
